import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ContactService } from 'src/app/services/contact.service';
import { LocationService } from 'src/app/services/location.service';
import * as fa from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss'],
})
export class PasswordComponent  implements OnInit {
  showCurrentPassword = false
  showNewPassword = false
  showConfirmPassword = false
  fa = fa

  form = new FormGroup({
    current_password: new FormControl('', [Validators.required]),
    new_password: new FormControl('', [Validators.required, Validators.minLength(12), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/)]),
    confirm_password: new FormControl('', [
      Validators.required,
      (control) => {
        if (!control.value) {
          return null;
        }
        const password = control.root.get('new_password');
        return password && control.value === password.value ? null : { passwordMismatch: true };
      }
    ]),
  })

  constructor(
    private contactService: ContactService,
    private locationService: LocationService, 
    private router: Router,
    private titleService: Title
  ) { }

  ngOnInit() {
    this.form.get('new_password')?.valueChanges.subscribe(() => {
      this.form.get('confirm_password')?.updateValueAndValidity({ onlySelf: true });
    });

    this.titleService.setTitle($localize `Change password`)
  }

  changePassword() {
    this.contactService.password(this.form.controls.current_password.value, this.form.controls.new_password.value).subscribe(result => {
      alert($localize `Password changed`)
      this.router.navigate(['/'])
    })
  }
}
